<template>
  <v-card>
    <!-- <v-card-title class="indigo white--text headline">
      User Directory
    </v-card-title> -->

    <v-layout
      justify-space-between
      pa-3
    >
      <app-section-loader :status="subtaskloader"></app-section-loader>
      <v-flex xs3>
        <vue-perfect-scrollbar
          class="chat-room--scrollbar grey lighten-5"
          v-bind:style="computeHeight"
        >
          <v-treeview
            :active.sync="active"
            :items="items"
            :open.sync="open"
            activatable
            active-class="primary--text"
            transition
            v-model="selectedTask"
            :open-all="true"
          >

          </v-treeview>
        </vue-perfect-scrollbar>
      </v-flex>

      <v-flex
        d-flex
        xs9
      >
        <vue-perfect-scrollbar
          class="chat-room--scrollbar lighten-5"
          v-bind:style="computeHeight"
        >
          <v-scroll-y-transition mode="out-in">
            <div
              v-if="!selected"
              class="title grey--text text--lighten-1 font-weight-light"
              style="align-self: center;"
              text-xs-center
            >
              Select a Task
            </div>
            <v-card
              v-else
              :key="selected.taskID"
              class="pt-4 mx-auto"
              flat
            >
              <v-card-text>
                <v-hover
                  open-delay="0"
                  close-delay="0"
                >
                  <v-layout slot-scope="{ hover }">
                    <v-flex
                      sm6
                      lg6
                    >
                      <h3
                        v-if="selected.hasPermission == true"
                        class="headline"
                      >
                        {{ selected.title | uppercase }}

                      </h3>
                      <h3
                        v-else
                        class="headline"
                        style="color:red;"
                      >
                        {{ selected.title | uppercase }}

                      </h3>
                    </v-flex>
                    <v-flex
                      sm3
                      lg3
                    >
                      <h5
                        v-if="selected.hasPermission == true"
                        class="headline"
                      >
                        {{ selected.dueDate | formatDate }}

                      </h5>
                      <h5
                        v-else
                        class="headline"
                        style="color:red;"
                      >
                        {{ selected.dueDate | formatDate }}

                      </h5>
                    </v-flex>

                    <v-flex
                      sm3
                      lg3
                    >
                      <v-btn
                        icon=""
                        v-if="selected.hasPermission == true"
                        @click="addMainTask(selected)"
                      >
                        <v-icon>
                          note_add
                        </v-icon>
                      </v-btn>
                      <v-btn
                        icon=""
                        v-if="selected.hasPermission == true"
                        @click="addSubTask(selected)"
                      >
                        <v-icon>
                          add_circle_outline
                        </v-icon>
                      </v-btn>
                      <v-btn
                        icon=""
                        v-if="selected.hasPermission == true"
                        @click="editSubTask(selected)"
                      >
                        <v-icon>
                          edit
                        </v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-hover>
              </v-card-text>
              <v-divider></v-divider>
              <v-layout
                tag="v-card-text"
                wrap
              >
                <v-flex v-if="selected.hasPermission == true">
                  <div v-html="selected.description"></div>
                </v-flex>
                <v-flex
                  v-else
                  style="color:red;"
                >
                  <div> You don't have permission to view this page details...</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-scroll-y-transition>
        </vue-perfect-scrollbar>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="subdialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <sub-task ref="refsubTaskForm"></sub-task>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            outline
            @click.native="subdialog = false"
          >Cancel</v-btn>
          <v-btn
            color="primary darken-1"
            outline
            @click.native="saveSubTask"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="taskdialog"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <task-form ref="refTaskForm"></task-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            outline
            @click.native="taskdialog = false"
          >Cancel</v-btn>
          <v-btn
            color="primary darken-1"
            outline
            @click.native="saveMainTask"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>

</template>
<script>
import SubTask from '@/pages/task/subtask';
import TaskForm from '@/pages/task/subtask';
import { getSubTasksId, getTaskTreeId, getTaskMastersbyID } from '@/api/taskMaster';


export default {
  components: {
    SubTask,
    TaskForm
  },
  data: () => ({
    subdialog: false,
    taskdialog: false,
    selecteditem: false,
    active: [],
    avatar: null,
    open: [],
    users: [],
    taskItems: [],
    subTaskitems: [],
    taskID: -1,
    formTitle: 'Sub Task',
    formdata: {
      valid: false,
      taskID: -1,
      parentTaskID: null,
      editedSubtaskIndex: -1,
      date: new Date(),
      title: '',
      assignedTo: null,
      dueDate: new Date(),
      description: '',
      projectID: null,
      assignedCC: [],
      readonlyUserID: [],
      readWriteUserID: [],
      selAssignedRights: [],
      onBehalfID: null,
      sessionID: '',
      addedByUserID: 1,
      addedDate: new Date(),
      addedByUser: 'Arun',
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserID: 1,
      modifiedDate: new Date(),
      requiredfield: [v => !!v || 'This is required field'],
      tagMasterID: -1,
      tagIds: [],
      personaltagIds: [],
      addedByUser: 'Arun',
      attachments: [],
      documentID: -1,
      documentAccessID: null,
      documentAccessName: null,
      sessionID: null,
      linkID: null,
      isSpecialFile: true,
      isTemp: true,
      description: '',
      uploadedFile: null,
      onBehalfName: '',
      overDueAllowed: 'false',
      followUp: 'false',
      mainTaskId: null,
    },
    subtaskloader: false,
    subtasktriggered: false,
    selectedTask: [],
  }),
  created () {
    window.getApp.$on('INITIALIZE_SUBTASK', taskID => {
      this.taskID = taskID;
      this.initialize();
    });
    window.getApp.$on('SEND_TASKOBJ', objTask => {
      this.formdata = objTask;
    });

  },
  computed: {
    computeHeight () {
      return {
        height: this.height || ''
      };
    },
    selected () {

      if (!this.active.length) {
        if (this.taskID > 0) {
          this.selecteditem = true;
          this.active.push(this.taskID);
          return this.taskItems.find(task => task.taskID == this.taskID);
        }
        else {
          return undefined
        }
      }
      const id = this.active[0]
      this.taskID = id;
      this.selecteditem = true;
      return this.taskItems.find(task => task.taskID == id);
    },
    items () {
      return this.subTaskitems;
    },
  },

  watch: {

  },

  methods: {

    initialize () {
      if (this.taskID > 0) {

        this.subtaskloader = true;
        let userId = this.$store.state.auth.userId;
        getTaskTreeId(this.taskID, userId)
          .then(response3 => {
            this.subTaskitems = response3.data;
            this.subtaskloader = false;

          })
          .catch(error => {
            this.subtaskloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });

        getSubTasksId(this.taskID, userId)
          .then(response3 => {
            this.taskItems = response3.data;
            this.subtaskloader = false;

          })
          .catch(error => {
            this.subtaskloader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });

      }
      else {
        this.subTaskitems = [];
      }
    },
    formateDate (string) {
      return string ? new Date(string).toLocaleDateString() : '';
    },

    editSubTask (item) {
      setTimeout(() => {
        window.getApp.$emit('SEND_TASKOBJ', this.formdata);
        window.getApp.$emit('EDIT_SUBTASK', item);
      }, 300);
      this.subdialog = true;
    },
    addSubTask (item) {
      this.formTitle = 'Add Sub Task';
      setTimeout(() => {
        window.getApp.$emit('SEND_TASKOBJ', this.formdata);
        window.getApp.$emit('ADD_SUBTASK', item);
      }, 300);
      this.subdialog = true;
    },
    addMainTask (item) {
      this.formTitle = 'Add Main Task';
      setTimeout(() => {
        window.getApp.$emit('SEND_TASKOBJ', this.formdata);
        window.getApp.$emit('ADD_MAINSUBTASK', item);
      }, 300);
      this.taskdialog = true;
    },
    saveSubTask () {
      this.subtasktriggered = false;
      window.getApp.$emit('SAVE_SUBTASK', this.taskID);
    },
    saveMainTask () {
      this.subtasktriggered = false;
      window.getApp.$emit('SAVE_SUBTASK', null);
    },

  }
}
</script>


// WEBPACK FOOTER //
// src/pages/task/subtasktree.vue